module.exports = __webpack_public_path__ + "static/media/home.ff53d6af.svg";